import {
  AugmentationComponent,
  AugmentationToolbarOptionNode
} from "@pathwright/ux/src/components/augmentation/AugmentationToolbar"
import { resolveToFromLinkProps } from "@pathwright/ux/src/components/link/Link"
import { useMemo } from "react"
import { useHistory } from "react-router-dom"
import CategoryFormContainer from "./item/CategoryFormContainer"
import { loadCategories, selectCategory } from "./middleware"

const CategoryManageAugmentationComponent: AugmentationComponent = ({
  route
}) => {
  const history = useHistory()

  const name = useMemo(() => {
    if (!route) return ""
    const searchParams = new URLSearchParams(route.location.search)
    return searchParams.get("name")?.trim() || ""
  }, [route?.location.search])

  function onClose() {
    if (!route) return
    const url =
      route.location.pathname + route.location.search + route.location.hash
    const relativeTo = resolveToFromLinkProps({ relativeTo: "../../" }, url)
    if (relativeTo) history.push(relativeTo)
  }

  return route ? (
    <CategoryFormContainer
      initialName={name}
      // Not supporting deletion for now (submit and delete buttons don't jive).
      canDelete={false}
      closeCard={onClose}
    />
  ) : (
    // Return a fragment instead of null to satisfy the type checker
    <></>
  )
}

export const categoriesManageToolbar: AugmentationToolbarOptionNode = {
  key: "category-manage",
  path: "categories/:categoryId(\\d+|new)",
  label: "Category",
  middleware: async (route) => {
    await loadCategories(route)
    await selectCategory(route)
  },
  AugmentationComponent: CategoryManageAugmentationComponent
}
